import Mixin from "../mixin.js";
import Utils from "../services/utils-service.js";
import Funnel from "../services/funnel-service.js";
import Label from "./utils/Label.js";

const template = `
<fieldset class="grid carrier-radio">
    <div :class="radio_count">
        <ul class="block-grid-s1 block-grid-m2" :class="gridClass" role="radiogroup"  aria-label="Carrier Selection" >
            <li class="s clm center checkbox-card" v-for="(item, index) in items" :uid="input.uid" role="radio" :aria-checked="setChecked(item)">
                <input type="radio"
                    :uid="input.uid+ '_option_' + index"
                    :id="input.id + '_option_' + index"
                    :required="input.validation.required"
                    :name="input.element_name"
                    :checked="setChecked(item)"
                    @change="exec($event, input)"
                    :value="item.value"
                    :disabled="setDisabled(item.disabled)"
                    v-bind="validationRules"
                    :data-uid="input.uid"
                    :aria-labelledby="input.uid+'_lb'"
                />
                <label
                    :label-for="input.uid+ '_option_' + index"
                    :for="input.uid+ '_option_' + index"
                    :class="computedLabelClass"
                    :data-uid="input.uid+'_lb'"
                    :id="input.uid+'_lb'"
                >
                        <span v-if="item.txt_only">{{item.label}}</span>
                        <img :alt="item.label" class="icon" :src="fs.icon(item)" v-if="icon(item)">

                </label>
            </li>
        </ul>
        <div class="error-here"></div>
        <input
            :uid="input.uid+ '_hidden_'"
            type="hidden"
            :id="input.id"
            :required="input.validation.required"
            :name="input.element_name"
            :value="input.value"
            :data-uid="input.uid+ '_hidden_'"
        />
    </div>
</fieldset>
`;


export default {
    name: 'qt-input-radio',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    components: {
        'qt-label': Label
    },
    mounted: function(){
        this.handleIIFE();
    },
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        computedLabelClass: function () {

            var statusClass = '';
            var labelClass = ''
            if (this.input.value) {
                statusClass = 'complete'
            }
            if (this.input.label_class) {
                labelClass = this.input.label_class
            }

            return labelClass + ' ' + statusClass
        },
        gridClass: function(){
            return 'block-grid-l5'
        },
        validationRules() {
            // v-bind="validationRules"
            return this.input.validation
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        items: function () {
            return { ... this.input.options };
        },
        radio_count: function () {
            var count = 0;
            var options = this.input.options
            if (options) {
                options.forEach(function (option) {
                    count++;
                });
            }
            if (count === 2) {
                var offset = 'clm m6  m-offset-3'
            } else if (count === 3) {
                var offset = 'clm m6 m-offset-3'
            } else if (count === 4) {
                var offset = 'clm m8 m-offset-2'
            } else if (count === 5) {
                var offset = 'clm m10 m-offset-1'
            }
            return offset;
        }

    },
    methods: {
        setChecked(item) {
            var checked = false;
            if (!Utils.isEmpty(this.input.value)) {
                checked = this.input.value.indexOf(item.value) > -1;
            }
            return checked;
        },
        icon: function (item) {
            if (item.txt_only) {
                return false
            }
            var text = item.label
            const pathToIcon = '/static/images/card-icons/'
            const iconFormat = '.svg'
            const iconName = text.toLowerCase().split(" ").join("-").replace(/[^a-zA-Z ]/g, "");

            return pathToIcon + iconName + iconFormat;
        },
    }
};
